import script from "./QModalEditAct.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalEditAct.vue?vue&type=script&setup=true&lang=js"

import "./QModalEditAct.vue?vue&type=style&index=0&id=7e1e6a1c&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e1e6a1c"]])

export default __exports__